
<template>
    <div>
        <!-- <q-icon size="70px"  name="far fa-user" color="primary" bordered style="position: absolute;z-index: 1;background-color:"/> -->
        <q-card flat bordered style="border: 1px solid #e9e9e9; border-radius: 0.5rem; height: 100%;">
            <q-card-section>
                <div class="text-bold" style="font-size: 16px;">{{$t("TacPage.accdetails")}}</div>
            </q-card-section>
            <q-separator style="margin: 0 0.75rem; width: auto;"/>
            <q-card-section >
                <div class="row q-px-sm" >
                    <div class="col-12 q-mb-md">
                        <b>{{$t("AccountHolder.investor")}}</b>
                        <div>{{StoreStateAOD.PersonalInformation.FullName}}</div>
                        <!-- <q-input :value="StoreStateAOD.PersonalInformation.FullName" readonly borderless/> -->
                    </div>
                    <div class="col-12 q-mb-md">
                        <b>{{$t("AccountHolder.epfno")}}</b>
                        <div>{{StoreStateAOD.PersonalInformation.EPFNumber}}</div>
                        <!-- <q-input :value="StoreStateAOD.PersonalInformation.EPFNumber" readonly borderless/> -->
                     </div>
                     
                        <div class="col-12 q-mb-md" >
                            <b>{{$t("AccountHolder.reference")}}</b>
                            <div>{{StoreStateT.referenceid}}</div>
                            <!-- <q-input :value="StoreStateT.referenceid" readonly borderless/> -->
                        </div> 
                        <div class="col-12 q-mb-md" >
                            <b>{{$t("AccountHolder.epftype")}}</b>
                            <div>{{StoreStateAOD.PersonalInformation.EPFAccount}}</div>
                            <!-- <q-input :value="StoreStateAOD.PersonalInformation.EPFAccount" readonly borderless/> -->
                        </div>
                    </div>
            </q-card-section>
        </q-card>
    </div>
</template>
 
<style>

.userHolder{
        width: 100%;
        font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
        font-size: 16px;
        background: #003c71;
        color: white;
        border-bottom-color: rgb(231, 231, 231);
}
</style> 
<script>
import { mapActions } from 'vuex';
import store from '../store'
export default {
    name : 'AccountDetails',
    components : {
    },
    data() {
        return {
            StoreStateT : store.state.Transactions,
			StoreStateAOD : store.state.AOD, 
        }
    },
    computed: {

    },
    mounted(){
    },
    methods: {

    }
}
</script>